/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SummaryTableSubTittleDto
 */
export interface SummaryTableSubTittleDto {
    /**
     * 
     * @type {string}
     * @memberof SummaryTableSubTittleDto
     */
    titleName: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryTableSubTittleDto
     */
    reference: string;
}

/**
 * Check if a given object implements the SummaryTableSubTittleDto interface.
 */
export function instanceOfSummaryTableSubTittleDto(value: object): value is SummaryTableSubTittleDto {
    if (!('titleName' in value) || value['titleName'] === undefined) return false;
    if (!('reference' in value) || value['reference'] === undefined) return false;
    return true;
}

export function SummaryTableSubTittleDtoFromJSON(json: any): SummaryTableSubTittleDto {
    return SummaryTableSubTittleDtoFromJSONTyped(json, false);
}

export function SummaryTableSubTittleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SummaryTableSubTittleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'titleName': json['titleName'],
        'reference': json['reference'],
    };
}

export function SummaryTableSubTittleDtoToJSON(value?: SummaryTableSubTittleDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'titleName': value['titleName'],
        'reference': value['reference'],
    };
}

